import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const MATCH_PAYMENT_TRACKING_SCHEMA = Object.freeze({
  PAYMENT_AMOUNT: '',
  PAYMENT_DATE: '',
  CLIENT_ID: '',
  TRANSACTION_ID: '',
  MATCH_TYPE: '',
});
const RECORD = generateSchema(MATCH_PAYMENT_TRACKING_SCHEMA);
const KEYS: any = generateKeys(MATCH_PAYMENT_TRACKING_SCHEMA);

export class MatchPaymentTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.match_payment;
  }

  get properties() {
    return this.toJS();
  }
}
